module.exports = __webpack_public_path__ + "img/JOC_3690.f80ba9a6.jpg";